import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityCategoryApi, EntityCategoryQuery } from 'api';

export const createEntityCategory = createAsyncThunk(
  'entityCategory/createEntityCategory',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityCategoryApi.create(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createMultiEntityCategory = createAsyncThunk(
  'entityCategory/createMultiEntityCategory',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityCategoryApi.createMulti(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeEntityCategory = createAsyncThunk(
  'entityCategory/removeEntityCategory',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityCategoryApi.remove(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeMultiEntityCategory = createAsyncThunk(
  'entityCategory/removeMultiEntityCategory',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityCategoryApi.removeMulti(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityCategory = createAsyncThunk(
  'entityCategory/updateEntityCategory',
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await EntityCategoryApi.update(params);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityCategoryStatus = createAsyncThunk(
  'entityCategory/updateEntityCategoryStatus',
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await EntityCategoryApi.updateStatus(params);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityCategorySort = createAsyncThunk(
  'entityCategory/updateEntityCategorySort',
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await EntityCategoryApi.updateSort(params);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityCategory = createAsyncThunk(
  'entityCategory/findEntityCategory',
  async (params: EntityCategoryQuery, { rejectWithValue }) => {
    try {
      const response = await EntityCategoryApi.filter(params);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityCategoryWithEntity = createAsyncThunk(
  'entityCategory/findEntityCategoryWithEntity',
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await EntityCategoryApi.findWithEntity(params);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityCategoryForTableList = createAsyncThunk(
  'entityCategory/findEntityCategoryForTableList',
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await EntityCategoryApi.findWithEntityForTable(params);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const findPartnerEntityCategory = createAsyncThunk(
  'entityCategory/findPartnerEntityCategory',
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await EntityCategoryApi.findWithPartnerEntity(params);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityCategoryForCategoryStep = createAsyncThunk(
  'entityCategory/findEntityCategoryForCategoryStep',
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await EntityCategoryApi.filter(params);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: Array<any>;
  listAll: Array<any>;
  categoriesHash: any;
  subCategoriesHash: any;
  partnerList: Array<any>;
  partnerListAll: Array<any>;
  partnerCategoriesHash: any;
}

const initialState: IState = {
  list: [],
  listAll: [
    {
      key: 'all',
      value: 'all',
      name: 'Tất cả danh mục',
    },
  ],
  categoriesHash: {},
  subCategoriesHash: {},
  partnerList: [],
  partnerListAll: [
    {
      key: 'all',
      value: 'all',
      name: 'Tất cả danh mục',
    },
  ],
  partnerCategoriesHash: {},
};

const entityCategorySlice = createSlice({
  name: 'entityCategory',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(findEntityCategoryWithEntity.fulfilled, (state, action) => {
      const { data } = action.payload;

      (data || []).forEach((e: any) => {
        const subCategories = e.entitySubCategories
          ?.sort((a, b) => a?.order - b?.order)
          .map((item: any) => {
            return {
              ...item,
              key: item.id,
              value: item.id,
              name: item.name || 'Chưa đặt tên',
            };
          });
        subCategories.forEach(subCategory => {
          state.subCategoriesHash[subCategory.id] = subCategory;
        });
        state.categoriesHash[e.id] = subCategories;
      });

      const newData = (data || []).map((item: any) => {
        return {
          ...item,
          key: item.id,
          value: item.id,
          name: item.isDefault
            ? `${item.displayName} (Mặc định)`
            : item.displayName,
        };
      });

      state.list = newData;

      state.listAll = [
        {
          key: 'all',
          value: 'all',
          name: 'Tất cả danh mục',
          displayName: 'Tất cả danh mục',
        },
        ...newData,
      ];
    });
    builder.addCase(findEntityCategory.fulfilled, (state, action) => {
      const { data } = action.payload;

      (data || []).forEach((e: any) => {
        const subCategories = e.entitySubCategories
          ?.sort((a, b) => a?.order - b?.order)
          .map((item: any) => {
            return {
              ...item,
              key: item.id,
              value: item.id,
              name: item.name || 'Chưa đặt tên',
            };
          });
        state.categoriesHash[e.id] = subCategories;
      });

      const newData = (data || []).map((item: any) => {
        return {
          ...item,
          key: item.id,
          value: item.id,
          name: item.isDefault
            ? `${item.displayName} (Mặc định)`
            : item.displayName,
        };
      });

      state.list = newData;

      state.listAll = [
        {
          key: 'all',
          value: 'all',
          name: 'Tất cả danh mục',
          displayName: 'Tất cả danh mục',
        },
        ...newData,
      ];
    });
    builder.addCase(findPartnerEntityCategory.fulfilled, (state, action) => {
      const { data } = action.payload;

      (data || []).forEach((e: any) => {
        const subCategories = e.entitySubCategories?.map((item: any) => {
          return {
            ...item,
            key: item.id,
            value: item.id,
            name: item.name || 'Chưa đặt tên',
          };
        });

        state.partnerCategoriesHash[e.id] = subCategories;
      });

      const newData = (data || []).map((item: any) => {
        return {
          ...item,
          key: item.id,
          value: item.id,
          name: item.isDefault
            ? `${item.displayName} (Mặc định)`
            : item.displayName,
        };
      });

      state.partnerList = newData;

      state.partnerListAll = [
        {
          key: 'all',
          value: 'all',
          name: 'Tất cả danh mục',
          displayName: 'Tất cả danh mục',
        },
        ...newData,
      ];
    });
  },
});

const { reducer: entityCategoryReducer } = entityCategorySlice;

export default entityCategoryReducer;
